module.exports = __webpack_public_path__ + "1ec92b0642143aceb7b042811e4d0f1c.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/hat-feather-red.png
// module id = 2875
// module chunks = 0